import { Radar, mixins } from 'vue-chartjs'

export default {
  extends: Radar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}

/* exemple de 'chartData', 'options'
chartGameData: {
  labels: [],
  datasets: [
    {
      label: 'game %',
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      borderColor: 'rgb(255, 99, 132)',
      pointBackgroundColor: 'rgb(255, 99, 132)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(255, 99, 132)',
      fill: true,
      data: []
    },
  ]
},
chartOptions: {
  scale: {
    ticks: {
      beginAtZero: true,
      min: 0,
      max: 100,
      stepSize: 20 // Optionnel, définit l'incrément des ticks
    }
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var label = data.labels[tooltipItem.index];
        var value = dataset.data[tooltipItem.index];
        return label + ': ' + value + '%';
      }
    }
  }
}
*/
